import { Action, Dispatch } from 'redux'
import { db, FirebaseTimestamp } from 'firebase/index'
import { push } from 'connected-react-router'
import { initBrandAction } from 'reducks/brand/actions'
import { fetchBrand, setBrand } from 'repos/brand'
import { fetchBrandStaffs, fetchStaff, setStaff } from 'repos/staff'
import { BrandState } from 'types/brand'

const saveBrand = (confirmBrand: BrandState['confirm'], storeManagerIds: string[]) => {
  return async (dispatch: Dispatch<Action>) => {
    const now = FirebaseTimestamp.now()
    const { brand_ref, name, store_refs } = confirmBrand
    if (!brand_ref) return

    // brand を更新する
    const prevBrand = await fetchBrand(brand_ref.id)
    await setBrand(brand_ref, {
      name,
      store_refs,
      created_at: prevBrand?.created_at ?? now,
      updated_at: now,
    })

    // ブランドマネージャーの権限を更新する
    for (const uid of storeManagerIds) {
      const staff = await fetchStaff(uid)
      if (!staff) continue
      const staffRef = db.collection('staffs').doc(uid)
      await setStaff(staffRef, {
        ...staff,
        roles: staff.roles.map((role) => {
          // ブランドに含まれる店舗の操作権限には brand_ref を含める
          if (store_refs.some((storeRef) => storeRef.id === role.store_ref.id)) {
            return {
              ...role,
              brand_ref,
            }
          } else {
            return role
          }
        }),
      })
    }

    // 更新前はブランドマネージャーだったが、今回対象外となった staff から権限を取り除く
    const prevBrandStaffs = await fetchBrandStaffs(brand_ref)
    for (const staff of prevBrandStaffs) {
      if (storeManagerIds.includes(staff.uid)) continue
      const staffRef = db.collection('staffs').doc(staff.uid)
      await setStaff(staffRef, {
        ...staff,
        roles: staff.roles.map((role) => {
          // 変更対象の brand を取り除く
          if (role.brand_ref?.id === brand_ref.id) {
            return {
              role: role.role,
              store_ref: role.store_ref,
            }
          } else {
            return role
          }
        }),
      })
    }

    // Redux store の brand を初期化する
    dispatch(initBrandAction())
    dispatch(push('/admin/brand'))
  }
}

export default saveBrand
